// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-checkbox__input.is-checked + .el-checkbox__label {\n  color: black !important;\n}\n", ""]);
// Exports
module.exports = exports;
